import { put } from 'redux-saga/effects'
import { IPcr } from '../../../../pcr/store/pcr.types'
import { setObstetrics } from '../store/obstetrics.actions'

export function* getObstetrics(pcrDoc: IPcr) {
  const obstetrics = pcrDoc.additionalAssessment?.obstetrics
  if (obstetrics && Object.keys(obstetrics).length !== 0) {
    yield put(setObstetrics(obstetrics))
  }
}
